import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'rma-skeleton-block',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SkeletonBlockComponent {
  @Input()
  @HostBinding('class.animate-pulse')
  animate = true;

  @Input()
  @HostBinding('class.rounded')
  rounded = true;

  @HostBinding('class.bg-steel-20')
  steel20 = true;

  @HostBinding('class.block')
  block = true;
}
